import { CodeLanguageIconSelector } from '@squareup/dex-feature-shared-main-code-language-icon-selector';
import SvgApiExplorerHome from '@squareup/dex-icons/dex/misc/ApiExplorerHome';
import { Link } from '@squareup/dex-ui';
import { Box, Display10, Paragraph30 } from '@squareup/dex-ui-shared-base';
import { MarketDivider } from '@squareup/dex-ui-shared-market';
import React, { FC } from 'react';

import styles from './api-explorer-home-container.module.css';

const strings = {
  title: 'API Explorer',
  description:
    'Send HTTP requests and view examples for Square APIs without writing code or setting up an environment.',
  needHelp: 'Need help?',
  readGuide: 'Read the API Explorer guide',
  sdkTitle: 'Build with SDKs',
  sdkDescription:
    "Leverage Square SDKs to generate requests in your preferred language. If you don't choose a language, requests will be generated as ",
  curl: 'cURL commands',
};

interface Props {
  isVersionSelectionLatest: boolean;
}

const ApiExplorerHomeContainer: FC<Props> = ({ isVersionSelectionLatest }) => {
  return (
    <Box
      className={styles['content']}
      padding={{ vertical: '4x', horizontal: '4x' }}
    >
      <SvgApiExplorerHome />
      <Box className={styles['content-section']}>
        <Display10>{strings.title}</Display10>
        <Paragraph30 colorVariant="20">{strings.description}</Paragraph30>
        <Box>
          <Paragraph30 colorVariant="20">
            {strings.needHelp}&nbsp;
            <Link
              className={styles['link'] as string}
              href="/docs/devtools/api-explorer"
              trackingId="read-api-explorer-guide"
            >
              {strings.readGuide}
            </Link>
          </Paragraph30>
        </Box>
      </Box>
      {isVersionSelectionLatest && (
        <>
          <Box className={styles['divider']}>
            <MarketDivider size="thin" />
          </Box>
          <Box className={styles['content-section']}>
            <Paragraph30 weight="semi-bold">{strings.sdkTitle}</Paragraph30>
            <Paragraph30 colorVariant="20">
              {strings.sdkDescription}
              <Link
                className={styles['link'] as string}
                href="https://curl.se/docs/manpage.html"
                target="_blank"
                trackingId="curl-commands"
              >
                {strings.curl}
              </Link>
              {'.'}
            </Paragraph30>
          </Box>
          <CodeLanguageIconSelector />
        </>
      )}
    </Box>
  );
};

export { ApiExplorerHomeContainer };
